'use client';

import React from 'react';

import { Tooltip } from '@/components/tooltip';
import { cn } from '@/utils/styles';

export interface NotificationDotProps {
  tooltipContent: React.ReactNode;
  className?: string;
}

const NotificationDot = ({ tooltipContent, className }: NotificationDotProps) => {
  return (
    <Tooltip content={tooltipContent}>
      <div
        className={cn(
          "h-2 w-2 -translate-y-1/2 self-end rounded-full bg-yellowDark before:absolute before:left-0 before:h-2 before:w-2 before:animate-notification before:rounded-full before:bg-yellowDark before:content-['']",
          className,
        )}
      />
    </Tooltip>
  );
};

export { NotificationDot };
